
import React from "react";
import { Switch, Route, useLocation, useParams } from "react-router-dom";

import Index from "./App/Pages";
import Home from "./App/Pages/Parts/Home";
import NotFound from "./App/Pages/404";
import Affiliate from "./App/Pages/Affiliate";
import Rakeback from "./App/Pages/Rakeback";
import BonusAff from "./App/Pages/Affiliate/Bonus";
import Bonus from "./App/Pages/Bonus";
import AboutUs from "./App/Pages/AboutUs";
import Rules from "./App/Pages/Rules";
import Faq from "./App/Pages/Faq";
// import Vip from "./App/Pages/Vip";

import Login from "./App/Pages/Auth/Login";
import Register from "./App/Pages/Auth/Register";
import UserStat from "./App/Components/User/Stat/Modal";
import GameStat from "./App/Components/Game/Stat";
import UserSetting from "./App/Components/User/Setting";
import GamesHome from "./App/Games";
import Wingo from "./App/Games/Wingo/Wingo";
import SlotsHome from "./App/Slots/index";
import Slots from "./App/Slots/Game";
import SportsHome from "./App/Sports";

import Crash from "./App/Games/Crash";
import Keno from "./App/Games/Keno";
import Wheel from "./App/Games/Wheel";
import Limbo from "./App/Games/Limbo";
import Mine from "./App/Games/Mine";
import Hilo from "./App/Games/Hilo";
import Hashdice from "./App/Games/HashDice";
import ClassicDice from "./App/Games/ClassicDice";
import SingleKeno from "./App/Games/SingleKeno";
import Plinko from "./App/Games/Plinko";
import VideoPoker from "./App/Games/VideoPoker";
import Blackjack from "./App/Games/BlackJack";
import Goal from "./App/Games/Goal";
import Roulette from "./App/Games/Roulette";
import SnackAndLadders from "./App/Games/SnakeAndLadders";
import ThreeCardMonte from "./App/Games/ThreeCardMonte";
import MagicWheel from "./App/Games/MagicWheel";
import Tower from "./App/Games/Tower";
import Diamond from "./App/Games/Diamond";
import HighLow from "./App/Games/HighLow";
import Lottery from "./App/Games/Lottery";
import VipClub from "./App/Pages/VipClub";
import Promotions from "./App/Components/Promotions";
import AffiliateDashboard from "./App/Components/AffiliateDashboard";
import ProvablyFair from "./App/Pages/Parts/ProvableFair";
import GlobalSettings from "./App/Pages/Parts/GlobalSettings";
import Chat from "./App/Pages/Parts/Chat";
import Casino from "./App/Pages/BCCasino/Casino";
import styled from "styled-components";
import Dashboard from "../src/App/Pages/Affiliate/Pages/Dashboard";
import MyRewards from "../src/App/Pages/Affiliate/Pages/MyRewards";
import RateAndRules from "../src/App/Pages/Affiliate/Pages/RateAndRules";
import RefferalCodesAndFriends from "../src/App/Pages/Affiliate/Pages/RefferalCodesAndFriends";
import DownloadBanners from "../src/App/Pages/Affiliate/Pages/DownloadBanners";
import GameProvider from "./App/Pages/BCCasino/gameProvider";
import { AiOutlineHome } from "react-icons/ai";
import { PiGiftLight } from "react-icons/pi";
import { IoWalletOutline } from "react-icons/io5";
import { BiSupport } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import BonusSignup from "./App/Pages/Bonus/BonusSingup";
// import Pick2 from "./App/Games/Lottery/Pick2";

import Payment from "./App/Pages/Parts/Payment_wallet/Payment";
import PaymentSuccess from "./App/Pages/Parts/Payment_wallet/PaymentSuccess";
import AllProviders from "./WC_Api/AllProviders";
import JillieJdb from "./WC_Api/JillieJdb";
import ProtectedRoute from "./ProtectedRoute";
import ForgetPassword from "./App/Pages/Auth/ForgetPassword";

// import Jocker from "./App/Games/Jocker";

const MainRoute = styled.div`
  @media (max-width: 576px) {
    margin-top: 50px;
  }
`;
const ReferralRoute = (props) => {
  const { referralCode } = useParams(); // Use the hook inside a valid functional component
  console.log("code", referralCode);
  return (
    <Index
      t={props.t}
      content={
        <Home
          t={props.t}
          content={
            <Register
              referral={referralCode}
              history={props.history}
              show={true}
            />
          }
        />
      }
    />
  );
};

function Router(props) {
  const handleTabClick = (e) => {
    const tabs = document.querySelectorAll(".snapbet-bottom-bar-main li a");
    tabs.forEach((tab) => tab.classList.remove("active"));
    e.currentTarget.classList.add("active");
  };

  let location = useLocation();
  let background = location.state && location.state.background;
  let loc = location.pathname;
  const { t } = props;
  return (
    <>
      <MainRoute>
        <Switch history={props.history} location={background || location}>
       
          
          <Route
            path="/register"
            children={
              <Index
                t={t}
                content={
                  <Home
                    t={t}
                    content={
                      <Register t={t} history={props.history} show={true} />
                    }
                  />
                }
              />
            }
          />
           <Route
            path="/resetPassword"
            children={
              <Index
                t={t}
                content={
                  <Home
                    t={t}
                    content={
                      <ForgetPassword t={t} history={props.history} show={true} />
                    }
                  />
                }
              />
            }
          />
          <Route path="/referal/:referralCode" component={ReferralRoute} />
          <Route
          path="/providers/:categoryId"
          children={<Index t={t} content={<AllProviders t={t} />} />}
        />
        <Route
            path="/login"
            children={
              <Index
                t={t}
                content={
                  <Home
                    t={t}
                   
                  />
                }
              />
            }
          />
         <ProtectedRoute>

         <Route
            exact
            path="/"
            children={<Index t={t} location={loc} content={<Home t={t} />} />}
          />
          
        <Route
          path="/jdb"
          children={<Index t={t} content={<JillieJdb t={t} />} />}
        />
        <Route
          path="/jillie"
          children={<Index t={t} content={<JillieJdb t={t} />} />}
        />
          
          <Route
            path="/wingo"
            children={
              <Index
                t={t}
                content={
                  <Wingo
                    t={t}
                    content={
                      <Login t={t} history={props.history} show={true} />
                    }
                  />
                }
              />
            }
          />
          <Route
            path="/casino"
            children={<Index t={t} content={<Casino />} />}
          />
          {/* Games for a specific Provider */}
          <Route path="/casino/providers/:id" component={GameProvider} />
          <Route
            path="/setting"
            children={
              <Index
                t={t}
                content={<UserSetting t={t} history={props.history} />}
              />
            }
          />
          {/* <Route
          path="/affiliate-dashbaord"
          children={
            <Index
              t={t}
              content={<AffiliateDashboard/>}
            />
          }
        /> */}
          <Route
            path="/provably-fair"
            children={<Index t={t} content={<ProvablyFair />} />}
          />
          <Route
            path="/global-settings"
            children={<Index t={t} content={<GlobalSettings />} />}
          />
          <Route
            path="/affiliate"
            children={
              <Index
                t={t}
                content={<Affiliate t={t} history={props.history} />}
              />
            }
          />
          <Route
            path="/promotions"
            children={
              <Index
                t={t}
                content={<Promotions t={t} history={props.history} />}
              />
            }
          />
          <Route
            path="/rakeback"
            children={
              <Index
                t={t}
                content={<Rakeback t={t} history={props.history} />}
              />
            }
          />
          <Route
            path="/lottery"
            children={
              <Index
                t={t}
                content={<Lottery t={t} history={props.history} />}
              />
            }
          />
          {/* <Route
          path="/pick2"
          children={
            <Index t={t} content={<Pick2 t={t} history={props.history} />} />
          }
        /> */}
          <Route
            path="/aff"
            children={
              <Index
                t={t}
                content={
                  <BonusAff params={location} history={props.history} t={t} />
                }
              />
            }
          />
          <Route
            path="/rules"
            children={
              <Index
                t={t}
                content={
                  <Rules params={location} history={props.history} t={t} />
                }
              />
            }
          />
          <Route
            path="/faq"
            children={
              <Index
                t={t}
                content={
                  <Faq params={location} history={props.history} t={t} />
                }
              />
            }
          />
          {/* <Route
            path="/chat"
            children={
              <Index
                t={t}
                content={
                  <Chat params={location} history={props.history} t={t} />
                }
              />
            }
          /> */}
          <Route
            path="/user/:id"
            children={
              <Index
                t={t}
                content={
                  <Home
                    t={t}
                    content={
                      <UserStat
                        t={t}
                        history={props.history}
                        params={location}
                        byLink={true}
                      />
                    }
                  />
                }
              />
            }
          />
          <Route
            path="/game/:id"
            children={
              <Index t={t} content={<GameStat t={t} params={location} />} />
            }
          />
         
      
          
          <Route
            path="/limbo"
            children={<Index t={t} content={<Limbo t={t} />} />}
          />
          <Route
            path="/hash-dice"
            children={<Index t={t} content={<Hashdice t={t} />} />}
          />
          <Route
            path="/classic-dice"
            children={
              <Index
                t={t}
                content={<ClassicDice t={t} history={props.history} />}
              />
            }
          />
         
          
          <Route
            path="/hilo"
            children={
              <Index t={t} content={<Hilo t={t} history={props.history} />} />
            }
          />
         
         
          <Route
            path="/blackjack"
            children={
              <Index t={t} content={<Blackjack history={props.history} />} />
            }
          />
          <Route
            path="/goal"
            children={
              <Index t={t} content={<Goal history={props.history} />} />
            }
          />
         
          
          
          {/* <Route path="/jocker" children={<Index t={t} content={<Jocker history={props.history} />} />} />*/}
          {/* {/<Route path="/baccarat" children={<Index t={t} content={<Baccarat history={props.history} />} />} />/} */}
         
          <Route
            path="/tower"
            children={
              <Index t={t} content={<Tower history={props.history} />} />
            }
          />
          <Route
            path="/diamond"
            children={
              <Index t={t} content={<Diamond history={props.history} />} />
            }
          />
          <Route
            path="/high-or-low"
            children={
              <Index t={t} content={<HighLow history={props.history} />} />
            }
          />
          <Route
            path="/slots/:id"
            children={
              <Index t={t} content={<Slots t={t} history={props.history} />} />
            }
          />
          <Route
            path="/slots"
            children={<Index t={t} content={<SlotsHome t={t} />} />}
          />
          <Route
            path="/casino/originals"
            children={<Index t={t} content={<GamesHome t={t} />} />}
          />
          {/* Route with category parameter */}
          <Route path="/casino/:category" element={<Casino />} />
          <Route
            path="/bonusSignup"
            children={<Index t={t} content={<Bonus t={t} />} />}
          />
          <Route
            path="/bonus"
            children={<Index t={t} content={<BonusSignup t={t} />} />}
          />

          <Route
            path="/about-us"
            children={<Index t={t} content={<AboutUs t={t} />} />}
          />
           <Route
          path="/payment"
          children={<Index t={t} content={<Payment t={t} />} />}
        />

        <Route
          path="/PaymentSuccess"
          children={<Index t={t} content={<PaymentSuccess t={t} />} />}
        />
          <Route path="/affiliate/dashboard" element={<Dashboard />} />
          <Route path="/affiliate/my-rewards" element={<MyRewards />} />
          <Route
            path="/affiliate/referral-codes-and-friends"
            element={<RefferalCodesAndFriends />}
          />
          <Route path="/affiliate/rate-and-rules" element={<RateAndRules />} />
          <Route
            path="/affiliate/download-banners"
            element={<DownloadBanners />}
          />
          <Route path="/sports" children={<Index t={t} content={<SportsHome t={t} />} />} />
          <Route
            path="/vip-club"
            children={<Index t={t} content={<VipClub t={t} />} />}
          />
           </ProtectedRoute>
          <Route path="*">
            <NotFound history={props.history} />
          </Route>
         
        </Switch>
      </MainRoute>
    </>
  );
}

export default Router;
